
import React, { useState, useEffect } from 'react';
import { ref, onValue, update } from 'firebase/database';
import { database } from '../firebase-config';

const AssignChildrenToParent = () => {
    const [parents, setParents] = useState([]);
    const [students, setStudents] = useState([]);
    const [classes, setClasses] = useState([]);
    const [selectedParent, setSelectedParent] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [feedbackMessage, setFeedbackMessage] = useState('');

    useEffect(() => {
        const usersRef = ref(database, 'users');
        onValue(usersRef, (snapshot) => {
            const users = snapshot.val();
            if (users) {
                const allParents = Object.keys(users).filter(uid => users[uid].role === 'parent').map(uid => ({ uid, ...users[uid] }));
                const allStudents = Object.keys(users).filter(uid => users[uid].role === 'student').map(uid => ({ uid, ...users[uid] }));
                setParents(allParents);
                setStudents(allStudents);
            }
        });

        const classesRef = ref(database, 'classes');
        onValue(classesRef, (snapshot) => {
            if (snapshot.exists()) {
                setClasses(Object.keys(snapshot.val()));
            }
        });
    }, []);

    const handleAssign = () => {
        if (!selectedParent || selectedStudents.length === 0) {
            setFeedbackMessage('Please select a parent and at least one student.');
            return;
        }

        const updates = {};
        selectedStudents.forEach(studentId => {
            updates[`/users/${selectedParent}/children/${studentId}`] = true;
            updates[`/users/${studentId}/parent`] = selectedParent;
        });

        update(ref(database), updates)
            .then(() => {
                setFeedbackMessage('Students assigned to parent successfully!');
                setSelectedParent('');
                setSelectedClass('');
                setSelectedStudents([]);
            })
            .catch((error) => {
                setFeedbackMessage(`Error: ${error.message}`);
            });
    };

    const filteredStudents = selectedClass ? students.filter(s => s.class === selectedClass) : students;

    return (
        <div>
            <h2>Assign Students to Parent</h2>
            {feedbackMessage && <p>{feedbackMessage}</p>}
            <div>
                <label>Select Parent:</label>
                <select value={selectedParent} onChange={(e) => setSelectedParent(e.target.value)}>
                    <option value="">-- Select a Parent --</option>
                    {parents.map(p => <option key={p.uid} value={p.uid}>{p.fullName} ({p.email})</option>)}
                </select>
            </div>
            <div>
                <label>Filter Students by Class:</label>
                <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
                    <option value="">-- All Classes --</option>
                    {classes.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
            </div>
            <div>
                <label>Select Students:</label>
                <select
                    multiple
                    value={selectedStudents}
                    onChange={(e) => setSelectedStudents(Array.from(e.target.selectedOptions, option => option.value))}
                    style={{ height: '200px' }}
                >
                    {filteredStudents.map(s => <option key={s.uid} value={s.uid}>{s.fullName} ({s.regNo})</option>)}
                </select>
            </div>
            <button onClick={handleAssign}>Assign Students</button>
        </div>
    );
};

export default AssignChildrenToParent;
